// Section IDs
export const SECTION_IDS = {
    FAVORITES: 'favorites-section',
    DEVICE_FILTERS: 'device-filters-section',
    STATUS_FILTERS: 'status-filters-section',
    SOFTWARE_FILTERS: 'software-filters-section',
    INCLUDE_DEVICES: 'include-devices-section',
    EXCLUDE_DEVICES: 'exclude-devices-section',
    OTHER_FILTERS: 'other-filters-section',
} as const;

// Group Names
export const GROUP_NAMES = {
    FAVORITES: 'Favorites',
    DEVICE_FILTERS: 'Device Filters',
    STATUS_FILTERS: 'Status Filters',
    SOFTWARE_FILTERS: 'Software Filters',
    INCLUDE_DEVICES: 'Include Devices',
    EXCLUDE_DEVICES: 'Exclude Devices',
    OTHER_FILTERS: 'Other Filters',
} as const;

// Menu Item Labels
export const MENU_ITEM_LABELS = {
    VIEW_FAVORITES: 'View Favorites',
    DEVICE_TYPE: 'Device Type',
    VEHICLE_VARIANT: 'Vehicle Variant',
    HW_VARIANT_PREFIX: 'Hardware Variant Prefix',
    HW_VARIANTS: 'Hardware Variants',
    DEVICE_HEALTH_TYPES: 'Device Health Types',
    DEVICE_STATUS: 'Device Status',
    PROD_MODE: 'Production Mode',
    IVD_MISMATCH: 'IVD Mismatch',
    BLOCKED: 'Blocked',
    REPLACED: 'Replaced',
    IN_CUSTOMER_FLEET: 'Activated',
    TEST_RELEASES_ACTIVE: 'Test Devices',
    ESSENTIAL_IMAGE: 'Essential Image',
    DISTRO_VERSION: 'Distro Version',
    SW_VERSION: 'SW Version',
    INSTALLED_DELIVERABLES: 'Installed Deliverables',
    HAS_MMT_PROPERTIES: 'Has MMT Properties',
    MMT_HEAD_UNIT: 'MMT Head Unit',
    MMT_FUNCTIONS: 'MMT Functions',
    VEHICLE_ENERGY_TYPE: 'Vehicle Energy Type',
    GROUPS: 'Groups',
    DEVICE_WHITELIST: 'Device Whitelist',
    VINS_WHITELIST: 'VINs Whitelist',
    SHORT_VINS_WHITELIST: 'Short VINs Whitelist',
    GROUPS_BLACKLIST: 'Groups',
    DEVICE_BLACKLIST: 'Device Blacklist',
    MILEAGE: 'Mileage',
    SPARE_PART_NUMBER: 'Spare Part Number',
} as const;

// Menu Item Keys
export const MENU_ITEM_KEYS = {
    DEVICE_TYPE: 'device-type',
    VEHICLE_VARIANT: 'vehicle-variant',
    HW_VARIANT_PREFIX: 'hw-variant-prefix',
    HW_VARIANTS: 'hw-variants',
    DEVICE_HEALTH_TYPES: 'device-health-types',
    DEVICE_STATUS: 'device-status',
    PROD_MODE: 'prod-mode',
    IVD_MISMATCH: 'ivd-mismatch',
    BLOCKED: 'blocked',
    REPLACED: 'replaced',
    IN_CUSTOMER_FLEET: 'in-customer-fleet',
    TEST_RELEASES_ACTIVE: 'test-releases-active',
    ESSENTIAL_IMAGE: 'essential-image',
    DISTRO_VERSION: 'distro-version',
    SW_VERSION: 'sw-version',
    INSTALLED_DELIVERABLES: 'installed-deliverables',
    HAS_MMT_PROPERTIES: 'has-mmt-properties',
    MMT_HEAD_UNIT: 'mmt-head-unit',
    MMT_FUNCTIONS: 'mmt-functions',
    VEHICLE_ENERGY_TYPE: 'vehicle-energy-type',
    GROUPS: 'groups',
    DEVICE_WHITELIST: 'device-whitelist',
    VINS_WHITELIST: 'vin-list',
    SHORT_VINS_WHITELIST: 'short-vin-list',
    GROUPS_BLACKLIST: 'groups-blacklist',
    DEVICE_BLACKLIST: 'device-blacklist',
    MILEAGE: 'mileage',
    SPARE_PART_NUMBER: 'spare-part-number',
} as const;

// Individual Filter IDs
export const FILTER_IDS = {
    DEVICE_TYPE: 'device-type-filter',
    VEHICLE_VARIANT: 'vehicle-variant-filter',
    HW_VARIANT_PREFIX: 'hw-variant-prefix-filter',
    HW_VARIANTS: 'hw-variants-filter',
    DEVICE_HEALTH_TYPES: 'device-health-types-filter',
    DEVICE_STATUS: 'device-status-filter',
    PROD_MODE:'prod-mode',
    IVD_MISMATCH: 'ivd-mismatch-filter',
    BLOCKED: 'blocked-filter',
    REPLACED: 'replaced-filter',
    IN_CUSTOMER_FLEET: 'in-customer-fleet-filter',
    TEST_RELEASES_ACTIVE: 'test-releases-active-filter',
    ESSENTIAL_IMAGE: 'essential-image-filter',
    DISTRO_VERSION: 'distro-version-filter',
    SW_VERSION: 'sw-version-filter',
    INSTALLED_DELIVERABLES: 'installed-deliverables-filter',
    HAS_MMT_PROPERTIES: 'has-mmt-properties-filter',
    MMT_HEAD_UNIT: 'mmt-head-unit-filter',
    MMT_FUNCTIONS: 'mmt-functions-filter',
    VEHICLE_ENERGY_TYPE: 'vehicle-energy-type-filter',
    GROUPS: 'groups-filter',
    DEVICE_WHITELIST: 'device-whitelist-filter',
    VINS_WHITELIST: 'vins-whitelist-filter',
    SHORT_VINS_WHITELIST: 'short-vins-whitelist-filter',
    GROUPS_BLACKLIST: 'groups-blacklist-filter',
    DEVICE_BLACKLIST: 'device-blacklist-filter',
    MILEAGE: 'mileage-filter',
    SPARE_PART_NUMBER: 'spare-part-number-filter',
} as const;

// Search Placeholder
export const SEARCH_PLACEHOLDER = 'Search filters...';
